<form #form="ngForm" (ngSubmit)="save(form)">
  <div class="p-fluid p-formgrid-del p-grid p-mb-0" *ngIf="options.prompt">
    <div class="p-field p-col-12 p-mb-0 {{options.promptStyleClasses}}">
      {{options.prompt}}
    </div>    
  </div>

  <!-- Row 1 -->
  <div class="p-fluid p-formgrid-del p-grid p-mt-2">
    <div class="p-field p-col-12 {{mdClasses.presetDateRange}}" *ngIf="options.showPresetDateRange">
      <span class="p-float-label">
        <p-dropdown [options]="dateRanges" 
                    class="p-inputtext-sm" 
                    appendTo="body"
                    showClear="true"
                    inputId="ppsDateRange" 
                    name="ppsDateRange" 
                    optionLabel="title"
                    [autoDisplayFirst]="false"
                    dataKey="id"
                    [(ngModel)]="selectedDateRange"
                    (onChange)="onDateRangeChanged($event)"></p-dropdown>
        <label for="ppsDateRange">{{options.presetDateRangeLabel}}</label>
      </span>
    </div>

    <div class="p-field p-col-12 {{mdClasses.fromDate}}" *ngIf="options.showFromDate">
      <span class="p-float-label">
        <p-calendar class="p-inputtext-sm" 
                    appendTo="body"
                    showIcon="true" 
                    dateFormat="dd/mm/yy"
                    inputId="fromDate"
                    name="fromDate"
                    [yearNavigator]="true" [yearRange]="yearRange"
                    [monthNavigator]="true" 
                    selectOtherMonths="true"
                    required
                    #fromDate="ngModel"
                    [(ngModel)]="dateRange.range.from"
                    [class.field-error]="form.submitted && fromDate.invalid"></p-calendar>
        <label for="fromDate" class="required-field">{{options.fromDateLabel}}</label>
      </span>
      <small class="p-error" *ngIf="form.submitted && fromDate.invalid">{{options.fromDateLabel}} date is required!</small>
      <small class="p-error" *ngIf="message">{{message}}</small>
    </div>

    <div class="p-field p-col-12 {{mdClasses.toDate}}" *ngIf="options.showToDate">
      <span class="p-float-label">
        <p-calendar class="p-inputtext-sm" 
                    appendTo="body"
                    showIcon="true" 
                    dateFormat="dd/mm/yy"
                    inputId="toDate"
                    name="toDate"
                    [yearNavigator]="true" [yearRange]="yearRange"
                    [monthNavigator]="true" 
                    selectOtherMonths="true"
                    required
                    #toDate="ngModel"
                    [minDate]="options.minToDate"
                    [maxDate]="options.maxToDate"
                    [(ngModel)]="dateRange.range.to"
                    [class.field-error]="form.submitted && toDate.invalid"></p-calendar>
        <label for="toDate" class="required-field">{{options.toDateLabel}}</label>
      </span>
      <small class="p-error" *ngIf="form.submitted && toDate.invalid">{{options.toDateLabel}} date is required!</small>
      <small class="p-error" *ngIf="message">{{message}}</small>
    </div>
  </div> 
  
  <div class="modal-footer">
    <button pButton pRipple label="Ok" class="p-button" icon="pi pi-save" type="submit"></button>
    <button pButton pRipple label="Cancel" class="p-button" icon="pi pi-times" type="button" (click)="cancel()"></button>
  </div>
</form>
